import { ApplicationType } from '@cfra-nextgen-frontend/shared/src/utils';
import { getPreferencesStorageKey } from '../UserInitialPreferencesContext';

export const clearAllLocalPreferences = (applicationType: ApplicationType) => {
    const key = getPreferencesStorageKey(applicationType, true);
    window?.localStorage?.removeItem(key);
};

export const clearImpersonationedUser = () => {
    window?.localStorage?.removeItem('impersonated-email');
}
